import { Container,  Row } from 'react-bootstrap';
 import {TopRatedGridSection} from '../topRatedStyle'
import CustomCard from '../../../components/common/customCard';
import { TopRatedGridProp } from '../../../utils/types';

const TopRatedGrid = ({category,selectedFilter,data}:TopRatedGridProp) => {
   
    return (
       <TopRatedGridSection> 
       <Container className="cont-w">
        <Row> 
        <CustomCard 
            cardData={data} 
            selectedCity={selectedFilter}  
            selectedCategory={category} 
        />
        </Row>
        </Container>
        </TopRatedGridSection>
    )
};
export default TopRatedGrid;